<template>
    <div>
        <h3>Response: </h3>
        <span v-if="response">
            <p>{{ response }}</p>
        </span>
    </div>
</template>

<script>

import BaseButton from '../../argon/components/BaseButton';
import { NCH_ENV } from '../../../../js/nch-env';

export default {
    name: 'dev-broadcast',
    components: {
        BaseButton,
    },
    data() {
        return {
            response: false,
        };
    },
    methods: {
    },
    created() {
        window.Echo.private(`${NCH_ENV.APP_HOST}.website`)
            .listen('WebsiteNotificationEvent', (e) => {
                this.response = e.data;
            });
    },
};
</script>
